import * as actions from "./actionsTypes";

const initialData = {
  loaderDetailTraining: false,
  detailTraining: null,
  detailTrainingFail: null,
  saveLoaderDetailTraining: false,
  detailTrainingFormError: null,
};

export default function DetailTrainingReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_DETAIL_TRAINING:
      return { ...state, loaderDetailTraining: action.payload };

    case actions.GET_DETAIL_TRAINING:
      return { ...state, detailTraining: action.payload };

    case actions.DETAIL_TRAINING_FAIL:
      return { ...state, detailTrainingFail: action.payload };

    case actions.SAVE_LOADER_DETAIL_TRAINING:
      return { ...state, saveLoaderDetailTraining: action.payload };

    case actions.FORM_DETAIL_TRAINING_FAIL:
      return { ...state, detailTrainingFormError: action.payload };

    default:
      return state;
  }
}
